module.exports = __webpack_public_path__ + "img/apoio-gef.5308984c.png";